import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../../utils/request';

const getWarehouseDuplicates = createAsyncThunk('warehouse/getWarehouseDuplicates',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/co/warehouse/duplicates');
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default getWarehouseDuplicates;
